import moment from 'moment';
import { FC, useEffect, useState } from "react";
import Details from "../../../../components/detailsList";
import SimpleCard from "../../../../components/simpleCard";
import LeasingStore from "../../../../contexts/leasingStore";
import _t from "../../../../lang/translate";
import { LeasingAdminType, LeasingCaseType } from "../../../../types/leasingTypes";
import format from "../../../../utilities/formatNumbers";
import MotorAgencyReportView from "./motorAgencyView";

export function getLeasingExpirationDate(leasingCase: LeasingCaseType, adminValues: LeasingAdminType | null) {
  let result = null;
  if (leasingCase.deal.input.leasingPeriod && adminValues?.deal?.activeSettings.startDateDmr) {
    const date = moment(adminValues.deal.activeSettings.startDateDmr).add(leasingCase.deal.input.leasingPeriod, 'month').subtract(1, 'day');
    result = date.toISOString();
  }
  return result
}

const LeasingAdminMotorAgency: FC = () => {
  const { adminValues, leasingCase } = LeasingStore.useContainer();
  const { actualRestValue, currentLeasingMonth } = adminValues?.deal || {};
  const [expectedExpirationDate, setExpectedExpirationDate] = useState<string | null>(null);

  useEffect(() => {
    const date = getLeasingExpirationDate(leasingCase, adminValues)
    setExpectedExpirationDate(format.date(date));
  }, [leasingCase, adminValues]);
  return (
    <>
      <SimpleCard title={_t("actual", "leasing_info")}>
        <Details borderLess>
          <Details.Item label={_t("actual_leasing_month")} value={currentLeasingMonth || "-"} />
          <Details.Item
            label={_t("actual_restValue")}
            value={actualRestValue ? `${format.price(actualRestValue)} (${_t("exclude_short", "vat")})` : "-"}
          />
          <Details.Item label={_t("expected", 'expiration_date')} value={expectedExpirationDate || "-"} />
        </Details>
      </SimpleCard>
      <SimpleCard className="mb-0" title={_t("DMR", "info")}>
        <MotorAgencyReportView />
      </SimpleCard>
    </>
  );
};

export default LeasingAdminMotorAgency;
